<!-- ========== SECONDARY CONTENTS ========== -->
<!-- Precios Modal -->

<mat-dialog-content class="modal-dialog">
  <div class="modal-content">
    <button type="button" mat-dialog-close class="close position-absolute top-0 right-0 z-index-2 mt-3 mr-3" data-dismiss="modal" aria-label="Close">
      <svg aria-hidden="true" class="mb-0" width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z" />
      </svg>
    </button>

    <!-- Body -->
    <div class="modal-body">
      <div class="bloque_home membresia">
        <h1 mat-dialog-title>Precios de Membresía</h1>
        <h2 mat-dialog-title>Ayúdanos a mejorar cada día para poder darte un mejor servicio mientras te diviertes y formas parte de la familia EDATV.</h2>
        <div class="botonera_planes">
          <a (click)="clickMes()" [ngClass]="mesActive ? 'active' : ''" ref="mes">MES</a>
          <a (click)="clickSemestre()" [ngClass]="semActive ? 'active' : ''" ref="semes">SEMESTRE</a>
          <a (click)="clickAnyo()" [ngClass]="yearActive ? 'active' : ''" ref="anyo">AÑO</a>
        </div>
      </div>
      <a href="https://tribunaburgos.com/suscripcion/step1.php">
        <img class="plan_membresia plan_mes active" [hidden]="!mesActive" id="imgMes" src="/assets/images/suscripcion/home_plan_mes.webp" alt="membresia mes" width="100%" height="100%" />
        <img class="plan_membresia plan_semestre" [hidden]="!semActive" id="imgSem" src="/assets/images/suscripcion/home_plan_semestre.webp" alt="membresia semestre" width="100%" height="100%" />
        <img class="plan_membresia plan_anyo" [hidden]="!yearActive" id="imgYear" src="/assets/images/suscripcion/home_plan_anual.webp" alt="membresia año" width="100%" height="100%" />
      </a>
    </div>
    <!-- End Body -->
  </div>
</mat-dialog-content>
<!-- End Precios Modal -->
